<template>
    <section class="noData_container">
        <div class="result_content">
            <van-image width="45%" height="auto" fit="contain" :src="result_icon" class="result_icon">
                <template v-slot:loading>
                    <van-loading type="spinner" size="100" />
                </template>
            </van-image>
            <div class="result_title">{{ result_title }}</div>
        </div>
        <van-divider>
            <div style="text-align:center;">
                Copyright ©
                {{$enumObject.providerConfig[config.projectName].copyrightInfo.subject}}
                <br />
            </div>
        </van-divider>
    </section>
</template>

<script>
    import noData from '@/assets/payment-related/noData@2x.png'
    import config from '@/config/index'
    import { Divider } from 'vant'
    export default {
        components: {
            [Divider.name]: Divider
        },
        data() {
            return {
                config,
                result_icon: noData,
                result_title: '您还没有相关订单'
            }
        }
    }
</script>

<style lang="scss" scoped>
    .noData_container {
        height: 100vh;

        .result_content {
            display: flex;
            justify-content: center;
            flex-direction: column;
            flex-wrap: nowrap;
            height: calc(100vh - 80px);
            text-align: center;

            .result_icon {
                width: 120px;
                height: auto;
                margin: 0 auto 20px;
            }

            .result_title {
                height: 40px;
                line-height: 40px;
                font-size: 22px;
            }
        }

        .button_box {
            padding: 0 10px 0;
        }
    }
</style>